import React from 'react';

interface WatercraftSpinnerProps {
  className?: string;
}

/**
 * Brand loading spinner — an accent ring on a dark track. Pass `className` to
 * size and recolour it, e.g. on a button.
 */
export default function WatercraftSpinner({
  className = 'h-8 w-8 border-watercraft-border border-t-watercraft-accent',
}: WatercraftSpinnerProps): React.JSX.Element {
  return (
    <div
      role='status'
      aria-label='Loading'
      className={`inline-block animate-spin rounded-full border-2 ${className}`}
    />
  );
}
